import type { SVGProps } from "react";

export function IconVideoVolumeLow(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      height="19"
      viewBox="0 0 19 19"
      width="19"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Video volume low</title>
      <path
        d="M8.414 3.824L4.59 6.883H1.531v4.589H4.59l3.824 3.059V3.824z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.887 6.469c.717.717 1.12 1.69 1.12 2.703 0 1.014-.403 1.987-1.12 2.704"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.72"
      />
    </svg>
  );
}
